/**
 * rect
 */
module.exports = (() => {

  let winY_ = 0;
  let winX_ = 0;

  const reset_ = () => {
    winY_ = window.pageYOffset;
    winX_ = window.pageXOffset;
  }

  /**
   * @param _$el {HTMLElement}
   * @return {object} area point
   */
  const getRect_ = (_$el) => {
    const rect_ = _$el.getBoundingClientRect();
    return {
      width : rect_.width,
      height: rect_.height,
      top   : rect_.top    + winY_,
      right : rect_.right  + winX_,
      bottom: rect_.bottom + winY_,
      left  : rect_.left   + winX_,
    }
  }

  return {

    /**
     * @param _$el {HTMLElement}
     * @return {object} area point
     */
    getRect: (_$el) => {
      reset_();
      return getRect_(_$el);
    },

    /**
     * @param _$$el {HTMLElement}
     * @return {object} areas point
     */
    getRects: (_$$el) => {
      reset_();
      return _.map(_$$el, (_$el) => {
        return getRect_(_$el);
      });
    },

  }

})();



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/module/rect.js
 **/